export const environment = {
  production: false,
  APIURL: 'https://apitest.dcscouting.se'
};
